import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LegalProvider } from '../providers/legal.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetLegalDisclaimerUseCase implements UseCase<Observable<Transaction<string>>> {
    constructor(private legalProvider: LegalProvider) {}

    bind(): Observable<Transaction<string>> {
        return this.legalProvider.text();
    }
}
